import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const e = () => /* @__PURE__ */ l.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ l.jsx("rect", { width: "40", height: "40", rx: "20", fill: "white" }),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 38.44C30.1841 38.44 38.44 30.1841 38.44 20C38.44 9.81587 30.1841 1.56 20 1.56C9.81587 1.56 1.56 9.81587 1.56 20C1.56 30.1841 9.81587 38.44 20 38.44ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M32.4701 30.8053L31.2916 29.7832C33.5655 27.1612 34.94 23.7431 34.94 20C34.94 16.2569 33.5655 12.8388 31.2916 10.2168L32.4701 9.1947C34.9807 12.0895 36.5 15.8673 36.5 20C36.5 24.1327 34.9807 27.9105 32.4701 30.8053ZM30.8053 7.52988L29.7832 8.70841C27.1612 6.4345 23.7431 5.06 20 5.06C16.2569 5.06 12.8388 6.4345 10.2168 8.70841L9.1947 7.52988C12.0895 5.01932 15.8673 3.5 20 3.5C24.1327 3.5 27.9105 5.01932 30.8053 7.52988ZM7.52988 9.1947C5.01932 12.0895 3.5 15.8673 3.5 20C3.5 24.1327 5.01932 27.9104 7.52988 30.8053L8.70841 29.7832C6.4345 27.1612 5.06 23.7431 5.06 20C5.06 16.2569 6.4345 12.8388 8.70841 10.2168L7.52988 9.1947ZM9.1947 32.4701L10.2168 31.2916C12.8388 33.5655 16.2569 34.94 20 34.94C23.7431 34.94 27.1612 33.5655 29.7832 31.2916L30.8053 32.4701C27.9104 34.9807 24.1327 36.5 20 36.5C15.8673 36.5 12.0895 34.9807 9.1947 32.4701Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ l.jsx("path", { d: "M18.125 25.625H21.875V29.375H18.125V25.625Z", fill: "black" }),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 14C18.2075 14 17 15.629 17 17H14C14 14.297 16.244 11 20 11C23.744 11 26 14.213 26 17C26 19.367 24.338 20.567 23.309 21.3095L23.135 21.4355C22.0025 22.2635 21.5 22.7345 21.5 23.75H18.5C18.5 21.107 20.2415 19.835 21.3605 19.0175L21.365 19.0145C22.613 18.101 23 17.7545 23 17C23 15.575 21.806 14 20 14Z",
      fill: "black"
    }
  )
] });
export {
  e as U
};
